package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.model.Language

/**
 * Segmented EN / FR / FA selector. [labelFor] supplies each language's display name LOCALIZED in
 * the ACTIVE UI language (owner direction 2026-07-12: English UI shows "Persian", Farsi UI shows
 * «انگلیسی/فرانسوی/فارسی») — callers pass string resources; this component contains no copy.
 * Selecting Farsi flips the whole app to RTL via the active-language theme wiring.
 */
@Composable
fun LanguageSwitcher(
    selected: Language,
    onSelect: (Language) -> Unit,
    labelFor: (Language) -> String,
    modifier: Modifier = Modifier,
) {
    Row(
        // Capped so the segments stay a control on desktop web instead of stretching to a
        // third of the card each (see sizes.segmentedMaxWidth).
        // widthIn BEFORE fillMaxWidth, deliberately: fillMaxWidth pins minWidth to the full
        // available width, and a later widthIn(max=) loses to that min — the cap silently did
        // nothing. Capping the max first, then filling, gives equal segments at 420dp.
        modifier = modifier.widthIn(max = AppTheme.sizes.segmentedMaxWidth).fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        Language.entries.forEach { language ->
            AppChip(
                label = labelFor(language),
                selected = language == selected,
                onClick = { onSelect(language) },
                modifier = Modifier.weight(1f),
            )
        }
    }
}
